export default __webpack_public_path__ + "static/media/greekgo-screenshot-03.c9330da3.png";